export class RoomSelectFindConditionViewModel {
    keyword = "";
    clear() {
        this.keyword = "";
    }
    copyFrom(condition) {
        this.keyword = condition.keyword;
    }
    get summary() {
        let txt = "";
        if (this.keyword) {
            txt += txt === "" ? "" : "、 ";
            txt += ` 契約者コード:${this.keyword}`;
        }
        return txt === "" ? "検索条件" : txt;
    }
}
